import React from 'react';
import PropTypes from 'prop-types';
import { Div, SubTitle } from 'ui';
import { injectIntl } from 'react-intl';
import FieldEngineerDropdown from './field-engineer-dropdown';

const engineerType = {
  name: PropTypes.string,
  number: PropTypes.string,
};

const FieldEngineer = ({
  intl,
  form,
  activeStatus,
  disabled,
  preferredEngineer,
  lastVisitEngineer,
  recommendedEngineers = [],
  engineer,
}) => {
  const defaultEngineer = preferredEngineer || lastVisitEngineer;
  const transformValues = values => values?.map((v) => {
    let { name } = v;
    if (defaultEngineer && v.number === defaultEngineer.number) {
      name = `${name} ${intl.formatMessage({ id: 'order.groupDropdown.DEFAULT' })} `;
    }
    return { ...v, name };
  });

  const groups = [
    {
      id: 'regions',
      name: intl.formatMessage({ id: 'order.groupDropdown.FIRST_GROUP' }),
      filter: workcenter => workcenter.isRegion,
    },
    {
      id: 'engineers',
      name: intl.formatMessage({ id: 'order.groupDropdown.SECOND_GROUP' }),
      filter: workcenter => !workcenter.isRegion,
    },
  ];

  return (
    <Div marginTop={45}>
      <SubTitle>
        {intl.formatMessage({ id: 'order.fieldEngineer.FSA_TITLE' })}
      </SubTitle>
      <FieldEngineerDropdown
        engineer={engineer || defaultEngineer}
        groups={groups}
        preferredEngineer={preferredEngineer}
        lastVisitEngineer={lastVisitEngineer}
        recommendedEngineers={recommendedEngineers}
        defaultEngineer={defaultEngineer}
        activeStatus={activeStatus}
        disabled={disabled}
        form={form}
        transformValues={transformValues}
      />
    </Div>
  );
};

FieldEngineer.propTypes = {
  engineer: PropTypes.shape(engineerType),
  preferredEngineer: PropTypes.shape(engineerType),
  lastVisitEngineer: PropTypes.shape(engineerType),
  form: PropTypes.object.isRequired,
  disabled: PropTypes.bool,
  activeStatus: PropTypes.object,
  intl: PropTypes.object,
  recommendedEngineers: PropTypes.array,
};

export default injectIntl(FieldEngineer);
